import {IRegexHelper} from "./regexTypes";

//TODO localization
export const PhoneRegex: IRegexHelper = {
  pattern: /^\d{10,12}$/,
  error: "From 10 till 12 digits without spaces",
}